import type { Service } from "./types";
import { BrainIcon } from "@/components/icons/services/brain-icon";
import { CloudIcon } from "@/components/icons/services/cloud-icon";
import { DataIcon } from "@/components/icons/services/data-icon";
import { LinkIcon } from "@/components/icons/services/link-icon";
import { MobileIcon } from "@/components/icons/services/mobile-icon";
import { SparklesIcon } from "@/components/icons/services/sparkles-icon";

export const services: Service[] = [
  {
    icon: <DataIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "Content on Autopilot",
    description: "Generate social media posts using insights from top performers while maintaining your brand voice. Workers create images, carousels, videos, and captions you approve before posting."
  },
  {
    icon: <SparklesIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "24/7 DM Receptionist",
    description: "Capture every lead across Instagram, WhatsApp, and Messenger. Digital receptionist responds instantly, qualifies prospects, and adds them to your CRM with full conversation context."
  },
  {
    icon: <LinkIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "Comment Engagement",
    description: "Never miss opportunities on social media. Track and auto-reply to comments across platforms, convert engaged followers into qualified prospects automatically."
  },
  {
    icon: <BrainIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "Find Your Best Customers",
    description: "Validate your market with real customer data. Combines automated research with actual social media interactions to identify profitable niches and refine your ideal customer profile."
  },
  {
    icon: <CloudIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "Leads That Actually Convert",
    description: "Find your ideal customers in online communities and professional networks. Workers engage with targeted responses while tracking every interaction to build your pipeline automatically."
  },
  {
    icon: <MobileIcon className="w-6 h-6" />,
    iconBg: "bg-card/50 border border-border",
    title: "See What's Working",
    description: "Data-driven decisions that multiply revenue. Track which workflows convert prospects, which content performs, and where to invest your time for maximum ROI."
  }
];